import getKeyFromMonthly from './getKeyFromMonthly'
import curry from 'utils/functional/curry'

const getBaseRate = curry(getKeyFromMonthly)('baseRate')

export default getBaseRate
